<template>
  <div>
    <addAndEdit></addAndEdit>
  </div>
</template>
<script>
import addAndEdit from '../components/addAndEdit.vue'

export default {
  components: {
    addAndEdit,
  },
}
</script>
